/* eslint-disable no-useless-catch */
import queryString from 'query-string';
import cookies from 'js-cookie';
import { AFFILIATE_COOKIE_NAME, DEFAULT_AGENCY_ID, customCampaignMapping } from '../constant';
import { DEFAULT_AFFILIATE_COOKIE_AGE } from '../constant/cookies';
import { getCookieDomain, stringifyPromo } from './util';
import { isBrowser } from './environment';
import {
  putBLGAgency,
  putBLGOfferCode,
  deleteBLGOfferCode,
  getCampaignDetails,
} from '../api/v2/search';

const expires = DEFAULT_AFFILIATE_COOKIE_AGE;

type Promo = {
  AgencyId?: string | null;
  AgencyID?: string | null;
  PromoCode?: string;
};

type PromoCookie = Promo & { Campaign?: string };

const setCampaignCookies = async (campaignData: Promo, campaign?: string | null) => {
  const cookieData = stringifyPromo(campaignData, campaign);
  if (isBrowser()) {
    cookies.set(AFFILIATE_COOKIE_NAME, cookieData, {
      expires: new Date(Date.now() + expires),
      domain: getCookieDomain(),
      httpOnly: false,
    });
  }
};

export const handlePromo = async (promoCookie?: string, campaign?: string | null) => {
  const localPromo = customCampaignMapping[campaign as keyof typeof customCampaignMapping];
  const currentCookiePromo = promoCookie ? (queryString.parse(promoCookie) as PromoCookie) : null;
  const existingValidPromo = localPromo || currentCookiePromo || {};
  const shouldFetchCampaign = campaign && !localPromo;

  let promo: Promo;

  try {
    if (shouldFetchCampaign) {
      promo = await getCampaignDetails({ campaignId: campaign });
    } else {
      promo = existingValidPromo;
    }

    // L&D don't link the affiliate cookie with blapi session, so we need to send the blapi requests when users get
    // to search from L&D. The Campaign value is set below, so if it doesn't exist the user should be coming from outside of search.
    const isComingFromOutsideOfSearch = !currentCookiePromo?.Campaign;
    const isSwitchingToDifferentCampaign = campaign && currentCookiePromo?.Campaign !== campaign;
    const isInitiatingNewPromo =
      !currentCookiePromo || isSwitchingToDifferentCampaign || isComingFromOutsideOfSearch;

    if (isInitiatingNewPromo) {
      await putBLGAgency({ id: promo.AgencyID || DEFAULT_AGENCY_ID });
    }

    if (isInitiatingNewPromo && promo?.PromoCode) {
      await putBLGOfferCode({ code: promo.PromoCode });
    }

    if (!promo?.PromoCode) {
      await deleteBLGOfferCode();
    }

    if (isInitiatingNewPromo) {
      setCampaignCookies(promo, campaign);
    }

    return {
      promoCode: promo?.PromoCode || existingValidPromo?.PromoCode,
      agencyId: promo?.AgencyID || existingValidPromo?.AgencyID,
    };
  } catch (error) {
    throw error;
  }
};
